// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var URLUtils$SmartcutsMacros = require("../../../bs-utils/src/URLUtils.bs.js");

function t_encode(v) {
  if (v) {
    return [
            "MatchesLinkPrefix",
            Decco.stringToJson(v._0)
          ];
  } else {
    return ["AnyLink"];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AnyLink" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AnyLink */0
                  };
          }
      case "MatchesLinkPrefix" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* MatchesLinkPrefix */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  if (v) {
    return "MatchesLinkPrefix(" + (v._0 + ")");
  } else {
    return "AnyLink";
  }
}

function getIntentionChoicesFromOriginAndHref(origin, href) {
  var baseChoices = [/* AnyLink */0];
  var url = URLUtils$SmartcutsMacros.$$URL.fromString(href);
  if (url !== undefined) {
    return $$Array.concat({
                hd: baseChoices,
                tl: {
                  hd: url.origin === origin ? [] : [/* MatchesLinkPrefix */{
                        _0: url.origin
                      }],
                  tl: {
                    hd: Belt_Array.reduce(Belt_Array.keep(url.pathname.split("/"), (function (s) {
                                  return s !== "";
                                })), [
                            [],
                            url.origin
                          ], (function (param, pathSegment) {
                              var nextPrefix = param[1] + ("/" + pathSegment);
                              return [
                                      $$Array.append(param[0], [/* MatchesLinkPrefix */{
                                              _0: nextPrefix
                                            }]),
                                      nextPrefix
                                    ];
                            }))[0],
                    tl: /* [] */0
                  }
                }
              });
  } else {
    return baseChoices;
  }
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.getIntentionChoicesFromOriginAndHref = getIntentionChoicesFromOriginAndHref;
/* URLUtils-SmartcutsMacros Not a pure module */
